import type { MapHeatmapQuery, MapHeatmapResponse } from '@repo/wemod-api/analytics/schema';
import { createWeModApi } from '@repo/wemod-api/base';
import { TOKEN_COOKIE_NAME } from './auth/constants';
import { readClientCookie } from './utils/cookie-utils';

export type { MapHeatmapQuery, MapHeatmapResponse };

export interface GetMapHeatmapOptions extends MapHeatmapQuery {
    bearerToken?: string | null;
}

/** Client-side fetch for title-scoped map activity heatmaps. */
export async function getMapHeatmap(
    titleId: number | string,
    options: GetMapHeatmapOptions,
): Promise<MapHeatmapResponse> {
    const bearerToken = options.bearerToken ?? readClientCookie(TOKEN_COOKIE_NAME);
    const api = createWeModApi({
        baseUrl: process.env.NEXT_PUBLIC_WEMOD_API_URL ?? '',
        getAuthToken: () => bearerToken,
    });

    const { data, error } = await api.analytics.heatmap.get(titleId, {
        eventTypes: options.eventTypes,
        days: options.days,
    });
    if (error !== null || data === null) {
        throw new Error(`Map heatmap request failed: ${error || 'request failed'}`);
    }
    return data;
}
